export const SIDEBAR_NAVIGATION_ITEM_CLASS = "sidebar-item";
